export enum HostedPageTypeEnum {
  CHECKOUT_NEW = 'CHECKOUT_NEW',
  CHECKOUT_EXISTING = 'CHECKOUT_EXISTING',
  UPDATE_CARD = 'UPDATE_CARD',
  UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD',
  MANAGE_PAYMENT_SOURCES = 'MANAGE_PAYMENT_SOURCES',
  COLLECT_NOW = 'COLLECT_NOW',
  EXTEND_SUBSCRIPTION = 'EXTEND_SUBSCRIPTION',
  CHECKOUT_GIFT = 'CHECKOUT_GIFT',
  CLAIM_GIFT = 'CLAIM_GIFT',
  CHECKOUT_ONE_TIME = 'CHECKOUT_ONE_TIME',
  PRE_CANCEL = 'PRE_CANCEL',
  VIEW_VOUCHER = 'VIEW_VOUCHER',
  _UNKNOWN = '_UNKNOWN',
}
